import { fetchDocumentFile } from "../../../api/documentsApi"
import { setDocumentsDownloadingState, setSelectedDocumentsAreLoading, showToastMessage } from "../../../stateManagement/reducers"
import { store } from "../../../stateManagement/store"
import { saveAs } from "file-saver";
import JSZip from "jszip";

export async function downloadDocumentFile(documentId: any, fileExtension: any, documentName: any, linkType: any) {
    const documentsDownloadingState = store.getState().documents.documentsDownloadingState
    store.dispatch(setDocumentsDownloadingState({ ...documentsDownloadingState, [documentId]: "isLoading" }))
    const documentFile = await fetchDocumentFile(documentId)
    if (documentFile) {
        let name = documentName
        if (fileExtension !== 'null') {
            name = documentName + fileExtension
        }
        if (linkType == 'Folder') {
            name = documentName + '.zip'
        }
        saveAs(documentFile, name);
        store.dispatch(setDocumentsDownloadingState({ ...documentsDownloadingState, [documentId]: "isSuccess" }))
    } else {
        store.dispatch(setDocumentsDownloadingState({ ...documentsDownloadingState, [documentId]: "isError" }))
        store.dispatch(showToastMessage({ messageText: "Ошибка скачивания документа", messageType: "error" }))
    }
}

export async function downloadSelectedDocumentFiles(documents: any) {
    const zip = new JSZip();
    const documentsDownloadingState = store.getState().documents.documentsDownloadingState
    let tempDocumentsDownloadingState = {}
    documents.map((document: any) => { tempDocumentsDownloadingState = { ...tempDocumentsDownloadingState, [document?.DocumentID]: "isLoading" } })
    store.dispatch(setDocumentsDownloadingState({ ...documentsDownloadingState, ...tempDocumentsDownloadingState }))
    store.dispatch(setSelectedDocumentsAreLoading(true))
    let finalDocumentsDownloadingState = {}
    await Promise.all(documents.map(async (document: any) => {
        const { DocumentID: documentId, FileExtension: fileExtension, LinkType: linkType, Name: documentName } = document ?? {}
        const documentFile = await fetchDocumentFile(documentId)
        if (documentFile) {
            let name = documentName
            if (fileExtension !== 'null') {
                name = documentName + fileExtension
            }
            if (linkType == 'Folder') {
                name = documentName + '.zip'
            }
            const content = await documentFile.arrayBuffer(); // читаем как ArrayBuffer
            finalDocumentsDownloadingState = {...finalDocumentsDownloadingState, [documentId]: "isSuccess"}
            zip.file(name, content);
        } else {
            finalDocumentsDownloadingState = {...finalDocumentsDownloadingState, [documentId]: "isError"}
        }
    }))
    const newDocumentsDownloadingState = store.getState().documents.documentsDownloadingState
    // Генерируем zip-файл
    const zipBlob = await zip.generateAsync({ type: "blob" });
    // Скачиваем архив
    saveAs(zipBlob, "Документы.zip");
    store.dispatch(setDocumentsDownloadingState({ ...newDocumentsDownloadingState, ...finalDocumentsDownloadingState }))
    store.dispatch(setSelectedDocumentsAreLoading(false))
}